import React, { useEffect, useState } from 'react';
import { Typography,Button, Card } from "@material-ui/core";
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
// import { AlertDialog } from '../../../componentes/MUI/AlertDialog';
// import Aceptaciones1raCredencial from '../../../componentes/Aceptaciones1raCredencial';
import {Documentos} from '../componentes/Documentos';

export const PantallaInicial = ({ datosPatrocinante, iniciarContinuar, documento,setDocumento,lecturas,setLecturas,cancelar }) => {
    return  <div className="min-h-screen py-12 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto">
        
        <Card className="p-8 md:p-12 shadow-sm border border-gray-200 rounded-xl bg-white">
          <div className="text-center mb-8">
          <Typography variant="h5" className="text-gray-800 font-bold mx-auto leading-relaxed">
            Para continuar con el proceso de solicitud de credenciales por favor lea atentamente las instrucciones siguientes:
          </Typography>
        </div>
          <div className="space-y-10">
            
            <section className="text-left">
              <Typography variant="h6" className="text-gray-900 font-bold mb-4">
                1 - Verifique la información que <b>{datosPatrocinante?.id_tramite?.ministro?.nombre || 'su patrocinante'}</b> ha brindado acerca de la iglesia a la cual usted pertenece.
              </Typography>
              
              <div className="bg-gray-50 rounded-lg p-6 mt-4 mb-4 border border-gray-200 space-y-4">
                <div>
                  <Typography className="text-sm font-bold text-gray-600 mb-1 uppercase tracking-tight">Usted pertenece a la iglesia:</Typography>
                  <ul className="list-disc ml-5 text-gray-900 font-medium">
                    <li>{datosPatrocinante?.iglesia.nombre}</li>
                  </ul>
                </div>
                <div>
                  <Typography className="text-sm font-bold text-gray-600 mb-1 uppercase tracking-tight">Su iglesia se encuentra ubicada en:</Typography>
                  <ul className="list-disc ml-5 text-gray-900 space-y-1">
                    <li>Provincia : {datosPatrocinante?.provincia.nombre}</li>
                    <li>Partido : {datosPatrocinante?.partido.nombre}</li>
                  </ul>
                </div>
              </div>

              <div className="mt-4">
                <Typography className="text-sm text-red-700 font-medium italic">
                  En caso de que alguno de estos datos no sea correcto por favor solicite a {datosPatrocinante?.id_tramite?.ministro?.nombre} que corrobore la información en cuestión.
                </Typography>
              </div>
            </section>

            <section className="text-left">
              <Typography variant="h6" className="text-gray-900 font-bold">
                2 - Lea los <a target="_blank" href='https://uadspace.nyc3.cdn.digitaloceanspaces.com/public_images/cre02_requisitos_estudios_teologicos.pdf' className="text-blue-700 underline hover:text-blue-900 font-semibold">requisitos de estudios teológicos</a> que debe cumplir para poder recibir credenciales en la UAD
              </Typography>
            </section>

            <section className="text-left space-y-3">
              <Typography variant="h6" className="text-gray-900 font-bold">
                3 - Asegúrese de contar con los elementos que se detallan a continuación los cuales deberán ser suministrados como archivos adjuntos en la siguiente sección:
              </Typography>
              <ul className="list-disc ml-6 text-gray-700 text-sm space-y-3">
                <li>Certificado de estudios teológicos en formato PDF</li>
                <li>Foto de su DNI (Frente) en formato jpg,jpeg o npg</li>
                <li>Foto de su DNI (Reverso) en formato jpg,jpeg o npg</li>
                <li>Foto tipo selfie reciente, donde su rostro se vea de forma clara y completa (no se aceptan fotos de fotos impresas), en formato JPG, JPEG o PNG</li>
                <li>Certificado de antecedentes penales en formato PDF</li>
                <li>Certificado de matrimonio si es casado/a en formato PDF</li>
              </ul>
            </section>

            <section className="text-left space-y-4">
              <Typography variant="h6" className="text-gray-900 font-bold">
                4 - Lea atentamente los documentos que se detallan a continuación sobre los cuales le pediremos su aceptación y conformidad en la siguiente sección:
              </Typography>
              <div className="flex flex-col space-y-3 ml-2">
                {[
                  { id: 'estatutos', label: 'Testimonio y Estatutos de la Unión de las Asambleas de Dios' },
                  { id: 'doctrina', label: 'Doctrinas Fundamentales de la Unión de las Asambleas de Dios' },
                  { id: 'compromiso', label: 'Compromiso Ministerial de la Unión de las Asambleas de Dios' }
                ].map((doc) => (
                  <div 
                    key={doc.id}
                    onClick={() => setDocumento(doc.id)}
                    className="flex items-center gap-3 p-2 hover:bg-gray-50 rounded cursor-pointer transition-colors group"
                  >
                    <BrowserUpdatedIcon fontSize="small" className="text-gray-400 group-hover:text-blue-700" />
                    <Typography className="text-blue-700 underline font-medium text-sm hover:text-blue-900">
                      {doc.label}
                    </Typography>
                  </div>
                ))}
              </div>
            </section>

            <section className="text-left space-y-3">
              <Typography variant="h6" className="text-gray-900 font-bold">
                5 - Disponga de la información que le pediremos sobre dos o tres personas que puedan dar referencias de su ministerio y testimonio:
              </Typography>
              <ul className="list-disc ml-6 text-gray-700 text-sm space-y-3">
                <li>Nombre / apellido / e-mail de su pastor</li>
                <li>Nombre / apellido / e-mail de un anciano o diácono de su iglesia</li>
                <li>Nombre / apellido / e-mail de su cónyuge</li>
              </ul>
            </section>

            <section className="text-left pt-6 border-t border-gray-100">
              <Typography variant="h6" className="text-gray-900 font-bold text-base">
                6 - Una vez que considere que cumple con las condiciones detalladas en los pasos anteriores haga clic en el botón "Continuar" y complete el formulario que encontrará a continuación.
              </Typography>
            </section>
          </div>

          <div className="mt-12 flex flex-col sm:flex-row justify-center gap-6">

          <Button
              variant="filled"
              color="red"
              onClick={cancelar}
              className="px-16 py-3 rounded-md normal-case text-sm font-bold border-red-200 text-red-500 hover:bg-red-50"
            >
              cancelar
            </Button>            
            <Button
              variant="outlined"
              color="blue"
              onClick={iniciarContinuar}
              className="px-16 py-3 rounded-md normal-case text-sm font-bold shadow-none hover:shadow-md"
            >
              Continuar
            </Button>
          
          </div>
        </Card>
      </div>

      <Documentos
          setDocumento={setDocumento}
          documento={documento}
          lecturas = {lecturas}
          setLecturas = {setLecturas}
      /> 
      {/* <AlertDialog 
        open={documento} 
        titulo={'Vista de lectura e impresión del documento'} 
        fullWidth={true}
        maxWidth={'md'}
        procesarCancelar={() => setDocumento(null)}
      >
        <Aceptaciones1raCredencial 
          tipo={documento} 
          objLecturas={{lecturas, setLecturas}} 
          instancia='lectura'
        />
      </AlertDialog> */}
    </div>
};